import React, { useRef, useState } from 'react'
import { Button, ConfigProvider, Modal } from 'antd'
import type { DraggableData, DraggableEvent } from 'react-draggable'
import Draggable from 'react-draggable'
import idataCodingStylesDark from '../../../pages/common/global-styles/idatacoding-dark.module.less'
import idataCodingStyles from '../../../pages/common/global-styles/idatacoding.module.less'
import zhCN from 'antd/es/locale/zh_CN'
export interface Props {
  open: boolean
  setOpen: any
  taskcount: number
  mode: string
  onOk?: () => void
}

const BatchTooltipModal: React.FC<Props> = (props) => {
  const { open, setOpen, taskcount, mode, onOk } = props
  // console.log(taskcount)

  const [disabled, setDisabled] = useState(false)
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const draggleRef = useRef<HTMLDivElement>(null)

  const showModal = () => {
    setOpen(true)
  }

  const handleOk = (e: React.MouseEvent<HTMLElement>) => {
    // console.log(e)
    setOpen(false)
  }

  const handleCancel = (e: React.MouseEvent<HTMLElement>) => {
    // console.log(e)
    setOpen(false)
  }

  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const { clientWidth, clientHeight } = window.document.documentElement
    const targetRect = draggleRef.current?.getBoundingClientRect()
    if (!targetRect) {
      return
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    })
  }

  return (
    <ConfigProvider locale={zhCN}>
      <Modal
        className={
          mode === 'user'
            ? idataCodingStylesDark.modalDark
            : mode === 'oam'
            ? idataCodingStyles.modalStyle
            : {}
        }
        closable={false}
        centered={true}
        title={
          <div
            style={{
              width: '100%',
              cursor: 'move',
            }}
            onMouseOver={() => {
              if (disabled) {
                setDisabled(false)
              }
            }}
            onMouseOut={() => {
              setDisabled(true)
            }}
            onFocus={() => {}}
            onBlur={() => {}}
          >
            提示
          </div>
        }
        visible={open}
        onOk={onOk}
        onCancel={handleCancel}
        // footer={[
        //     <Button key="stop" type="primary" onClick={handleOk}>确定</Button>,
        //     <Button key="cancel" onClick={handleCancel}>取消</Button>
        // ]}
        modalRender={(modal) => (
          <Draggable
            disabled={disabled}
            bounds={bounds}
            onStart={(event, uiData) => onStart(event, uiData)}
          >
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
      >
        <p>
          选中的{' '}
          <span
            style={mode === 'oam' ? { color: '#4f46e5' } : { color: '#a5b4fc' }}
          >
            {taskcount}
          </span>{' '}
          个任务正在运行中，确定要停止运行吗？
        </p>
      </Modal>
    </ConfigProvider>
  )
}

export default BatchTooltipModal
